import { cornerDecomposeMap } from './decomposer';
import { cornerComposeMap } from './composer';

export const corner = {
  decomposeMap: cornerDecomposeMap,
  composeMap: cornerComposeMap,
};
